import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import ImageIcon from '@material-ui/icons/Image';
import WorkIcon from '@material-ui/icons/Work';
import BeachAccessIcon from '@material-ui/icons/BeachAccess';
import Divider from '@material-ui/core/Divider';
import {Typography} from "@material-ui/core";
import Paper from "@material-ui/core/Paper";


const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        display: 'flex',
    },
}));

export default function Contacts() {
    const classes = useStyles();

    return (
        <Paper style={{padding: '15px'}}>
            <Typography>

                Вы можете воспользоваться статистикой для
                следующих сайтов: RomanceCompass, J4L, Zolushka. Для этого перейдите по ссылке: <a href={'http://help-chat.com.ua/stat-agency/index.html'} target={'_blank'}>Статистика</a>

                <br /><br />
            Обратиться по вопросам связанных с ботами, тех.проблемами, системой оплаты, предложениями и пожеланиями вы можете в telegram и viber:<br />
            </Typography>
            <List className={classes.root}>
                <ListItem style={{width: 'auto'}}>
                    <a target='_blank' href="https://t.me/HelpChatcomua" style={{display: 'contents'}}>
                        <ListItemAvatar>
                            <Avatar>
                                <img src={'/space/telegram.png'} style={{width: '100%'}}/>
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText primary="HELP-CHAT SUPPORT" />
                    </a>

                </ListItem>

                <ListItem  style={{width: 'auto'}}>
                    <a target='_blank' title="+380994162317" href="viber://chat?number=+380994162317" style={{display: 'contents'}}>
                        <ListItemAvatar>
                            <Avatar>
                                <img src={'/space/viber.png'}  style={{width: '100%'}}/>
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText primary="HELP-CHAT SUPPORT" />
                    </a>
                </ListItem>
            </List>

            Также подписывайтесь на наш новостной телеграмм канал для получения свежих новостей связанных с обновлениями и развитием нашего сервиса:<br />

            <ListItem>
                <a target='_blank' href="https://t.me/helpchatua" style={{display: 'contents'}}>
                    <ListItemAvatar>
                        <Avatar>
                            <img src={'/space/telegram.png'}  style={{width: '100%'}}/>
                        </Avatar>
                    </ListItemAvatar>
                    <ListItemText primary="HELP-CHAT NEWS" />
                </a>
            </ListItem><br />

            Спасибо, что выбрали наш сервис!<br />

            С уважением,<br /> команда "Help-Chat"<br />

        </Paper>
    );
}